import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/ActionTypes';
import SiteSettingsRecord from '../records/SiteSettingsRecord';
const DEFAULT_VALUE = fromJS({
  isRequesting: false,
  isFetched: false,
  data: null
});
export default function SiteSettingsReducer(state = DEFAULT_VALUE, action) {
  switch (action.type) {
    case ActionTypes.FETCH_SITE_SETTINGS_PENDING:
      return state.set('isRequesting', true);
    case ActionTypes.FETCH_SITE_SETTINGS_SUCCESS:
      return state.merge({
        isRequesting: false,
        isFetched: true,
        data: SiteSettingsRecord.fromJS(action.payload)
      });
    case ActionTypes.FETCH_SITE_SETTINGS_ERROR:
      return state.merge({
        isRequesting: false
      });
    default:
      return state;
  }
}